/**
 * 문자열에서 숫자 값 추출
 * @example "100Mbps" → 100
 * @example "-80dBm" → -80
 * @example "25dB" → 25
 * @example "18.5%" → 18.5
 * @example "5ppm" → 5
 */
export function parseNumericValue(value: string | number | undefined): number | null {
  if (value === undefined || value === null || value === "") {
    return null;
  }
  if (typeof value === "number") {
    return value;
  }
  // 숫자와 소수점, 음수 부호만 추출
  const match = value.match(/-?\d+\.?\d*/);
  return match ? parseFloat(match[0]) : null;
}

/**
 * 속도 문자열 파싱 (Mbps/Gbps 단위 처리)
 * @example "100Mbps" → 100
 * @example "1Gbps" → 1000
 */
export function parseSpeedValue(value: string | undefined): number | null {
  if (!value) return null;
  const lower = value.toLowerCase();
  const num = parseNumericValue(value);
  if (num === null) return null;

  if (lower.includes("gbps")) {
    return num * 1000; // Gbps → Mbps 변환
  }
  return num; // Mbps 그대로
}

/**
 * 범위 문자열 파싱
 * @example "60~80 dBuV" → { min: 60, max: 80 }
 * @example "1.260~1.280" → { min: 1.26, max: 1.28 }
 */
export function parseRangeValue(value: string | undefined): { min: number; max: number } | null {
  if (!value) return null;
  const match = value.match(/(-?\d+\.?\d*)\s*[~\-]\s*(-?\d+\.?\d*)/);
  if (!match) return null;
  return {
    min: parseFloat(match[1]),
    max: parseFloat(match[2]),
  };
}
